import {_} from 'lodash';
import PromiseRequest from "../../../../req/PromiseRequest";
import {IFormTemplate, IFormTemplatePage, IRouteDefinitionParams, IRuleset} from '../../../../index';
import {SPINNER} from "../../../../constants";
import {createErrorMessage, isBit} from "../../../../util/misc";
import {global} from "../../../../appContext";
import {PageData} from "../mutable/PageData"
import {template as tpl, viewModel as MutableViewModel} from "../mutable/details";
import {nsFormTemplate} from "../nsFormTemplate";
import {setRouteHash} from "../../../../constants/RouteDefinitions";
import openFormDialog = nsFormTemplate.openFormDialog;

export let template = tpl;

type T = IFormTemplate;

export class viewModel extends MutableViewModel {
    private readonly reqGetFormTemplate: PromiseRequest = global.getPromiseRequest('getformtemplate');
    protected readonly reqSubmit: PromiseRequest = new PromiseRequest('updateformtemplate');

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.init();
    }

    protected override init(): Promise<any> {
        return super
            .init()
            .then(() => {
                return this.reqGetFormTemplate
                    .request({id: global.getRouteId()})
                    .then((data: T[]) => {
                        const template = data[0];
                        if (!template) {
                            return;
                        }
                        this.data = template;
                        this.active(this.data.active);
                        this.published(this.data.published);
                        this.name(this.data.name);
                        if (this.data.availableto_id) {
                            this.availableTo({id: this.data.availableto_id} as IRuleset);
                        }
                        this.pages(_.sortBy(this.data.pages, 'order').map((p: IFormTemplatePage) => new PageData(p)));
                    })
            })
            .then(() => {
                this.authenticationTypes(this.allAuthenticationTypes.filter(a => isBit(a.flag, this.data.authenticationtypes)));
                this.customButtons.push({
                    cls: 'fa-link',
                    label: `Åpne skjema`,
                    onClick: () => openFormDialog(this.data),
                })
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
            });
    }

    /*******************************************************************************************************************
     * Submit
     ******************************************************************************************************************/

    protected onSubmit() {
        const data = this.getSubmitData();
        let jformtemplate = encodeURIComponent(JSON.stringify(data));

        this.isReady(false);
        this.messageData({message: `Oppdaterer skjemamal... ${SPINNER}`});
        this.reqSubmit.abort();
        this.reqSubmit
            .request({
                jformtemplate: jformtemplate,
            })
            .then(() => {
                global.snackbarData({message: 'Skjemamal er oppdatert.'});
                global.cacheManager.removeCache('getformtemplate');
                global.cacheManager.removeCache('searchformtemplate');
                global.cacheManager.removeCache('getehubprocess');
                setRouteHash('formtemplatedetails', {id: this.__id});
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)))
                this.isReady(true);
            });
    }

    override dispose() {
        super.dispose();
        this.reqGetFormTemplate.abort();
    }
}
